import { angularServicesNames } from "./angularServicesNames";

(function (module) {
    "use strict";
    module.factory('setLanguageInterceptor', [angularServicesNames.$translate, function ($translate: ng.translate.ITranslateService) {
        return {
            request: function (config: $TSFixMe) {
                const lang = $translate.use();
                if (lang) {
                    config.headers["Accept-Language"] = lang;
                }
                return config;
            },
            requestError: (c: $TSFixMe) => c,
            response: (res: $TSFixMe) => res,
            responseError:(res: $TSFixMe) => res,
        };
    }]);

    module.config(['$httpProvider', function ($httpProvider: ng.IHttpProvider) {
        $httpProvider.interceptors.push('setLanguageInterceptor');
    }]);


})(angular.module('topline.services'));